import React from 'react';
// native components
import OtherCommitmentsCallouts from '../../../components/otherCommitmentsCallouts';

export default () => (
  <OtherCommitmentsCallouts
    id='sustainability-impact-other-commitments-financial-access'
    data={{
      card1: {
        id: 'our-other-commitments-investing-in-communities',
        title: 'Investing in our communities',
        link: '/who-we-are/sustainability-impact/communities/',
      },
      card2: {
        id: 'our-other-commitments-culture-of-belonging',
        title: 'Strengthening our culture of belonging',
        link: '/who-we-are/sustainability-impact/culture/',
      },
      card3: {
        id: 'our-other-commitments-reducing-environmental-impact',
        title: 'Reducing our environmental impact',
        link: '/who-we-are/sustainability-impact/environment/',
      },
      card4: {
        id: 'our-other-commitments-earning-trust',
        title: 'Earning trust through corporate governance and reporting',
        link: '/who-we-are/sustainability-impact/governance/',
      },
    }}
  />
);
